(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('OrderHistoryController', OrderHistoryController);

    OrderHistoryController.$inject = ['$rootScope', '$translate', '$log', 'OrderHistoryService'];

    function OrderHistoryController($rootScope, $translate, $log, OrderHistoryService) {

        // VARIABLES
        var vm = this;

        vm.lang = $translate.use();

        // FUNCITONS DEFINITIONS
        vm.loaded = pageLoaded;
        vm.deletePart = deletePart;


        // OTHER
        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
        });

        loadData();

        return vm;

        function loadData() {
            OrderHistoryService.loadBookedAreas().then(successAreas, error);
            OrderHistoryService.loadBookedParts().then(successParts, error);
        }

        // FUNCTIONS
        function pageLoaded() {
            if (true) {
                return true;
            }
            return false;
        }

        function successParts(response) {
            $log.debug('OrderHistoryController | fetching parts', response.data);
            vm.parts = response.data;
        }

        function successAreas(response) {
            $log.debug('OrderHistoryController | fetching areas', response.data);
            vm.areas = response.data;
        }

        function error(response) {
            $log.debug('OrderHistoryController | ERROR:', response);
        }

        function deletePart(id) {
            OrderHistoryService.deletePart(id).then(successDelete, error);
        }

        function successDelete() {
            OrderHistoryService.loadBookedParts().then(successParts, error);
        }
    }
})();
